(function () {
    'use strict';

    angular.module("imApp").factory("componentAlternativesService", ['$ihttp', function ($ihttp) {
        let service = {
            getComponentAlternatives: function (parms) {
                return $ihttp.post({
                    method: 2402,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
